/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'./BaseTask'
], function(
	BaseTask
) {
	'use strict';

	var HighlighterTask = BaseTask.extend({

		/**
		 * Load the selection highlighter (or {{}) and store in the highligher member of the renderContext.
		 * @param renderContext - information collected by a particular call to render or reRender (such as the view, control, data etc).
		 * @returns a promise
		 */
		process: function(renderContext) {
			if (this._isStepComplete(renderContext, 'highlighter')) {
				return Promise.resolve(renderContext);
			}

			return this.getRenderState().getCurrentContextData('visView')
				.whenHighlighterReady()
				.then(function(highlighter) {
					this._completeStep(renderContext, 'highlighter', highlighter);
					return renderContext;
				}.bind(this))
				.catch(function(error) {
					this.showError('dwErrorRenderingVisualization');
					throw error;
				}.bind(this));
		}
	});

	return HighlighterTask;
});
